/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LoanCollateral { 
    collateralType?: string | null;
    memberId?: number | null;
    blockAmount?: number | null;
    accountNumber?: string | null;
    productName?: string | null;
    availableBalance?: number | null;
    shareSavingId?: number | null;
    fileType?: string | null;
    assetName?: string | null;
    assetType?: string | null;
    currentValuation?: number | null;
    comment?: string | null;
    documents?: string | null;
    fileData?: string | null;
    documentFileName?: string | null;
    accountBlockedAmount?: number;
}

